export const validateCardNumber = (number: string): boolean => {
  const cleaned = number.replace(/\s/g, '');
  if (cleaned.length < 13 || cleaned.length > 19) return false;

  let sum = 0;
  let isEven = false;

  for (let i = cleaned.length - 1; i >= 0; i--) {
    let digit = parseInt(cleaned[i]);

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  return sum % 10 === 0;
};

export const validateExpiry = (expiry: string): boolean => {
  if (!expiry || expiry.length !== 5) return false;

  const [month, year] = expiry.split('/');
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100;
  const currentMonth = currentDate.getMonth() + 1;

  const expMonth = parseInt(month);
  const expYear = parseInt(year);

  if (expMonth < 1 || expMonth > 12) return false;
  if (
    expYear < currentYear ||
    (expYear === currentYear && expMonth < currentMonth)
  )
    return false;

  return true;
};

export const validateCVV = (cvv: string): boolean => {
  const cleaned = cvv.replace(/\D/g, '');
  return /^\d{3}$/.test(cleaned);
};

export const validateHolder = (holder: string): boolean => {
  return /^[A-Za-z\s]{2,}$/.test(holder.trim());
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length >= 10 && cleaned.length <= 15;
};

export const validatePassword = (
  password: string
): {
  isValid: boolean;
  errors: string[];
} => {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('Пароль должен содержать минимум 8 символов');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну заглавную букву');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну строчную букву');
  }

  if (!/\d/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну цифру');
  }

  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы один специальный символ');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export const validateINN = (inn: string): boolean => {
  if (!/^\d{10}(\d{2})?$/.test(inn)) return false;

  const weights =
    inn.length === 10
      ? [2, 4, 10, 3, 5, 9, 4, 6, 8]
      : [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
  let sum = 0;

  for (let i = 0; i < weights.length; i++) {
    sum += parseInt(inn[i]) * weights[i];
  }

  const checkDigit = (sum % 11) % 10;
  return checkDigit === parseInt(inn[weights.length]);
};

export const validateSNILS = (snils: string): boolean => {
  const cleaned = snils.replace(/\D/g, '');
  if (cleaned.length !== 11) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned[i]) * (9 - i);
  }

  let checkDigit = sum % 101;
  if (checkDigit === 100) checkDigit = 0;

  return checkDigit === parseInt(cleaned.slice(9));
};

export const validatePassport = (series: string, number: string): boolean => {
  const seriesRegex = /^\d{4}$/;
  const numberRegex = /^\d{6}$/;

  return seriesRegex.test(series) && numberRegex.test(number);
};

export const getCardFieldError = (
  field: string,
  value: string,
  cardNumber?: string
): string => {
  switch (field) {
    case 'number':
      if (value.replace(/\s/g, '').length > 0 && !validateCardNumber(value)) {
        return 'Неверный номер карты';
      }
      break;
    case 'holder':
      if (value.length > 0 && !validateHolder(value)) {
        return 'Введите корректное имя';
      }
      break;
    case 'expiry':
      if (value.length === 5 && !validateExpiry(value)) {
        return 'Неверная дата истечения';
      }
      break;
    case 'cvv':
      if (value.length > 0 && !validateCVV(value)) {
        return 'CVV должен содержать 3 цифры';
      }
      break;
  }
  return '';
};
